



if($('a[href^="#"]').length > 0){
    $(document).on('click', 'a[href^="#"]', function (event) {
        event.preventDefault();

        if ($(this).attr("href").length > 1 ) {
          $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top
          }, 500);
        }

    })
}



// $('.menu--main .expanded > a').off('click').on('click', function(){
//     let link = $(this).attr('href');
//     if(link.startsWith("#")){
//         $('html, body').animate({
//             scrollTop: $($.attr(this, 'href')).offset().top
//         }, 500);
//     }else{
//         location.href = link;
//     }
// });
//





// WEBPACK FOOTER //
// ./web/themes/custom/atolbtob/js/components/scroll-to.js